import { OperationResult, RequestParameters } from '../types/apiTypes';
import api from './api';
import { buildUrlString } from './helpers';

class StopsApi {
    static base = '/ridership';

    static async getStopsInArea(agencyId: string, centerLat: number, centerLon: number, radiusMiles: number, parameters?: RequestParameters) {
        const params = {
            centerLat,
            centerLon,
            radiusMiles,
        } as const;
        const url = buildUrlString(params as any, agencyId, 'stops', 'area');
        return await api.doAuthGetRequestAsyncWithParams<OperationResult<any[]>>(`${this.base}/${url}`, parameters);
    }
}

export default StopsApi;
